import { getFlag } from '@mahawi/eshop-common/src/get-flag';
import { type ICountry } from '@mahawi/eshop-common/src/types';

export interface ICountryOption {
  value: string;
  label: string;
}

export const getCountryOptions = (
  countries: ICountry[] | undefined,
  isoCodeField: 'isoCode' | 'isoCode2' = 'isoCode',
): ICountryOption[] =>
  (countries ?? []).map((country: ICountry): ICountryOption => {
    const isoCode = country[isoCodeField];

    return {
      value: isoCode,
      label: `${getFlag({ countryTypeIsoCode: isoCode })} ${country.name} (${isoCode})`,
    };
  });
